export default __webpack_public_path__ + "static/media/prioridad.c9a921d6.svg";